export type SettingValueType = "integer" | "string" | "boolean";

export interface SystemSetting {
  key: string;
  value: unknown;
  value_type: SettingValueType;
  description: string;
  min_value: number | null;
  max_value: number | null;
  updated_at: string;
  updated_by: string | null;
}

export interface SystemSettingsResponse {
  settings: SystemSetting[];
}

export interface RegistryRowsResponse {
  table: string;
  rows: Record<string, unknown>[];
}

export type AiBackendMode =
  | "anthropic"
  | "ollama"
  | "openai_compatible"
  | "rule_based";

export interface AiBackendResponse {
  mode: AiBackendMode;
  description: string;
  model: string | null;
  base_url: string | null;
  api_key_set: boolean;
  env_vars: Record<string, boolean>;
}

export interface ScanConfigResponse {
  folder_scan_root: string | null;
  workbook_allowed_share_roots: string[];
  discovered_folders_count: number;
  env_vars: Record<string, boolean>;
}

export const REGISTRY_TABLES = [
  { slug: "project-types", label: "Project types" },
  { slug: "project-lifecycle-stages", label: "Lifecycle stages" },
  { slug: "document-roles", label: "Document roles" },
  { slug: "document-role-subtypes", label: "Document role sub-types" },
  { slug: "project-document-requirements", label: "Document requirements" },
  { slug: "folder-skip-rules", label: "Folder skip rules" },
] as const;

export type RegistrySlug = (typeof REGISTRY_TABLES)[number]["slug"];
